import React from 'react';

export default function Hero() {
  return (
    <section className="relative h-[400px] bg-cover bg-center" style={{ backgroundImage: "url('/profile_h.png')" }}>
      <div className="absolute inset-0 bg-black/30 z-10"></div>
      <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-white">
        <h1 className="text-4xl font-bold">All Profiles</h1>
      </div>
    </section>
  );
}